module.exports = __webpack_public_path__ + "img/rank-table-guy-2.e879a7ce.jpg";